<template>
	<div class="basis-page-cls breath-data-base">
		<table-search-index :defaultQuery="listQuery" :filterHeader="filterHeader" @filterSearch="filterSearch"></table-search-index>
		<section class="basis-cls_table">
		    <div class="header">
		        <span class="title el-icon-document"> 数据列表</span>
		        <div class="btns">
		            <el-button @click.stop="handleCreate" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增数据文件</el-button>
		        </div>
		    </div>
		    <div class="table">
				<table-pagination
					v-loading="loading"
		            pagination
		            :data="list"
		            :column="column"
		            :total="total"
		            :page.sync="listQuery.pageNumber"
		            :limit.sync="listQuery.pageSize"
		            @pagination="getList" />
		    </div>
		</section>
		<el-drawer
		    title="数据配置" 
		    :visible.sync="dialog_visible"
		    :wrapperClosable="false"
			size="800px"
		    direction="rtl">
				<section style="padding: 0 20px;">
					<el-steps :active="active" simple>
					  <el-step :title="title"></el-step>
					  <el-step title="字段映射"></el-step>
					</el-steps>
					<ExportStepFirst ref="exportStepFirst" @updateStepFirst="updateStepFirst" v-show="active == 1" @onCancel="dialog_visible = false"/>
					<ExportStepSecond v-show="active == 2" :stepSecond="stepSecond" @goBack="goBack" @updateStepSecond="updateStepSecond"/>
				</section>
				
		</el-drawer>
		<el-drawer title="修改文件" 
		    :visible.sync="dialog_visible_edit"
		    :wrapperClosable="false"
			size="800px"
		    direction="rtl">
			<el-form :model="edit_form" :rules="edit_rules" ref="edit_form" label-width="80px" style="padding: 0 20px;">
				<el-form-item label="文件名称" prop="name">
					<el-input v-model="edit_form.name" placeholder="请输入数据文件名称"></el-input>
				</el-form-item>
				<el-form-item style="float: right;">
				     <el-button @click="dialog_visible_edit = false">取消</el-button>
					 <el-button type="primary" @click="onEditSubmit">立即提交</el-button>
				</el-form-item>
			</el-form>
		</el-drawer>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import ExportStepFirst from './exportStepFirst.vue';
	import ExportStepSecond from './exportStepSecond.vue';
	
	export default {
		components:{
			ExportStepFirst,
			ExportStepSecond
		},
		name:'dataBase',
		computed: {
		    ...mapGetters([ 
				'subBrandList',
				'userInfo'
			])
		},
		data() {
			return {
				loading:false,
				filterHeader: [
					{label: '子品牌', model: 'childBrandIdentify', type: 'select', default: '', list: []},
					{label: '数据批次', model: 'name', type: 'input', default: ''},
				],
				listQuery:{
					brandIdentify:'',
					pageNumber:1,
					pageSize:10,
					name:'',
					childBrandIdentify:''
				},
				list:[],
				column:[
					{
					    label: '序号',
					    width: 80,
					    render: (h, scope) => {
					        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					    }
					},
					{ label: '数据文件名称', prop: 'name' },
					{ label: '最近导入时间', prop: 'createTime' },
					{ 
						label: '当前数据文件状态', 
						prop: 'status',
						render: (h,scope) => {
							return <span>{this.status_list[scope.row.status]}</span>
						}
					},
					{ label: '备注', prop: 'remarks' },
					{ label: '已生成任务', prop: 'taskCreatedCount' },
					{ label: '未生成任务', prop: 'taskNotCreatedCount' },
					{
					    label: '操作',
					    prop: 'cation',
					    align: 'center',
					    width: 180,
					    fixed: 'right',
					    render: (h, scope) => {
							return (
								<div>
									<el-link onClick={() => this.handleExport(scope.row)} underline={false} type="primary" 
									disabled={scope.row.status == 'importing' || scope.row.status == 'waiting'}>导入数据</el-link>
									<el-divider direction="vertical"></el-divider>
									<el-link onClick={() => this.handleEdit(scope.row)} underline={false} type="primary">修改</el-link>
									<el-divider direction="vertical"></el-divider>
									<el-link onClick={() => this.handleInfo(scope.row)} underline={false} type="primary"
									disabled={scope.row.status == 'importing' || scope.row.status == 'waiting'}>详情</el-link>
								</div>
							)
					    }
					}
				],
				total:0,
				title:'新增外呼数据文件',
				dialog_visible:false,
				active:1,
				stepSecond:{
					columnList:[],
					excelColumnList:[],
					batchNum:''
				},
				dialog_visible_edit:false,
				edit_form:{
					name:'',
					id:'',
					brandIdentify:''
				},
				edit_rules:{
					name:[{required:true,message:'请输入文件名称',trigger:'blur'}],
				},
				status_list:{
					'waiting':'等待导入中',
					'importing':'入库中',
					'success':'导入成功',
					'fail':'导入失败',
				}
				
			}
		},
		methods: {
			goBack(){
				this.active = 1;
			},
			updateStepFirst(data){
				this.active = 2;
				this.stepSecond = data;
			},
			updateStepSecond(data){
				this.dialog_visible = false;
				this.getList();
			},
			filterSearch() {
				this.loading = true;
				this.listQuery.pageNumber = 1;
				this.getList()
			},
			handleCreate(){
				this.dialog_visible = true;
				this.active = 1;
				this.title = '新增外呼数据文件';
				this.$nextTick(() => {
					this.$refs.exportStepFirst.onReset();
				})
				
			},
			handleExport(row){
				this.dialog_visible = true;
				this.active = 1;
				this.title = '导入外呼数据文件';
				this.$nextTick(() => {
					this.$refs.exportStepFirst.onEdit(row)
				})
			},
			handleEdit(row){
				this.dialog_visible_edit = true;
				this.edit_form.id = row.id;
				this.edit_form.name = row.name;
				this.edit_form.brandIdentify = row.brandIdentify;
			},
			onEditSubmit(){
				this.$refs.edit_form.validate((valid) => {
					if(valid){
						this.$api.updateBreathdataBaseListRowName(this.edit_form).then(res => {
							if(res.errcode != 0) return;
							this.$notify.success('修改成功');
							this.getList();
							this.dialog_visible_edit = false;
						})
					}
				})
			},
			handleInfo(row){
				this.$router.push({
					path:`/breathe/dataBase/info/${row.id}`,
					query: {
					   name: row.name
					}
			   })
			},
			
			getList(){
				this.listQuery.brandIdentify = this.userInfo.brandIdentify;
				this.$api.getBreathdataBaseFileList(this.listQuery).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.list = res.data;
					this.total = Number(res.total)
				}).catch(err => {
					this.loading = false;
				})
			},
		},
		created(){
			this.filterHeader[0]['list'] = this.subBrandList;
			this.listQuery.childBrandIdentify = this.userInfo.brandList && this.userInfo.brandList.length > 0 ? this.userInfo.brandList[0] : '';
			this.loading = true;
			this.getList()
		}
	}
</script>

<style>
</style>
